import { driver } from 'driver.js';
import '../main.css';
import 'driver.js/dist/driver.css';
export const privateNetworkDriverObj = (dispatch) => {
  const driverObj = driver({
    showProgress: true,
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    doneBtnText: 'Done',
    popoverClass: 'driverjs-theme',
    steps: [
      {
        element: '.createPrivateNetwork',
        popover: {
          title: 'Create Private Network',
          description:
            'Click here to set up a new private network. This allows you to establish isolated network environments tailored to specific needs.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.refreshPrivateNetwork',
        popover: {
          title: 'Refresh Network Data',
          description:
            'Use this option to refresh the current status and data of the private network. This ensures that you are viewing the most up-to-date information.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.editPrivateNetwork',
        popover: {
          title: 'Edit Private Network',
          description:
            'Modify the settings of an existing private network. Ensure that the network configuration meets your security and operational requirements.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.deletePrivateNetwork',
        popover: {
          title: 'Delete Private Network',
          description:
            'Remove an existing private network. Make sure that this network is no longer required, as deletion is irreversible.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.resourcePrivateNetwork',
        popover: {
          title: 'Manage Network Resources',
          description:
            'View and manage the resources allocated to this private network. This includes managing IP addresses, subnets, and other network resources.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.privateNetworkMainTable',
        popover: {
          title: 'Private Network Overview',
          description:
            'This table provides a comprehensive overview of all private networks. You can view, edit, and manage your networks from here.',
          side: 'left',
          align: 'start',
        },
      },
    ],
  });
  return driverObj;
};
export default privateNetworkDriverObj;
